import { EInterventionType } from 'models/Intervention';

export const INTERVENTION_TYPE = [
  { value: EInterventionType.LeakDetection, label: 'Leak detection' },
  { value: EInterventionType.CostPlus, label: 'Repair subcontracted' },
  { value: EInterventionType.QuoteNeeded, label: 'Repair based on quote' },
  { value: EInterventionType.UrgentIntervention, label: 'Urgent intervention' },
];

const interventionTypes = {
  allTypes: [
    EInterventionType.QuoteNeeded,
    EInterventionType.LeakDetection,
    EInterventionType.UrgentIntervention,
    EInterventionType.CostPlus,
  ],
  typesBasedOnQuote: [EInterventionType.QuoteNeeded],
  typesBasedOnUrgentOrCostPlus: [
    EInterventionType.UrgentIntervention,
    EInterventionType.CostPlus,
  ],
  typesBasedOnLeakDetection: [EInterventionType.LeakDetection],
};

export default interventionTypes;
